module.exports = __webpack_public_path__ + "build/img/exclam.2f2d221e.png";